var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Checkbox } from "../doconCheckbox";
import { BaseBox, FlexBox, GridBox } from "../../shared/Element";
import Image from "../../shared/Image";
import React from "react";
import styled, { css, ThemeProvider } from "styled-components";
import { doconTheme } from "../../../theme/default";
import { Body1, Body2, Heading3 } from "../../../doconV2";
var CheckboxWithoutLabel = styled(Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  float: right;\n"], ["\n  float: right;\n"])));
var Tile = styled(BaseBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  border: solid 1px var(--input-border-color);\n  display: inline-block;\n  width: ", ";\n  border-radius: 8px;\n  padding: 12px;\n  cursor: pointer;\n  background-color: var(--input-bg-color);\n  ", ";\n\n  ", "\n\n  ", " {\n    color: var(--body-color);\n    margin-bottom: 4px;\n  }\n"], ["\n  position: relative;\n  border: solid 1px var(--input-border-color);\n  display: inline-block;\n  width: ", ";\n  border-radius: 8px;\n  padding: 12px;\n  cursor: pointer;\n  background-color: var(--input-bg-color);\n  ", ";\n\n  ", "\n\n  ", " {\n    color: var(--body-color);\n    margin-bottom: 4px;\n  }\n"])), function (_a) {
    var $itemWidth = _a.$itemWidth;
    return $itemWidth + "px";
}, function (props) { return handleColors(props); }, function (props) { return props.isDisabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: not-allowed;    \n  "], ["\n    cursor: not-allowed;    \n  "]))); }, Body1);
var ImageComp = styled(Image)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  ", "\n"], ["\n  margin-bottom: 8px;\n  ", "\n"])), function (props) { return props.isDisabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    mix-blend-mode: luminosity;\n  "], ["\n    mix-blend-mode: luminosity;\n  "]))); });
var handleColors = function (props) {
    var _a = props.theme.v2.colors, input = _a.input, primary = _a.primary;
    return "\n    --body-color: " + primary[1] + ";\n    --input-border-color: " + (props.checked ? primary[0] : input.borderColor) + ";\n    :hover {\n      --input-border-color:" + (props.isDisabled ? input.borderColor : primary[0]) + ";\n    }\n  ";
};
var CheckboxTile = function (_a) {
    var name = _a.name, value = _a.value, itemWidth = _a.itemWidth, checked = _a.checked, isDisabled = _a.isDisabled, handleClick = _a.handleClick, children = _a.children;
    function handleTileClick() {
        if (isDisabled)
            return;
        handleClick && handleClick({ name: name, value: value, isSelected: checked });
    }
    return (React.createElement(Tile, { "$itemWidth": itemWidth, checked: checked, isDisabled: isDisabled, onClick: handleTileClick }, children));
};
var DoconCheckboxTile = function (_a) {
    var _b = _a.itemWidth, itemWidth = _b === void 0 ? 160 : _b, _c = _a.place, place = _c === void 0 ? 'right' : _c, options = _a.options, selected = _a.selected, disabled = _a.disabled, onChange = _a.onChange, props = __rest(_a, ["itemWidth", "place", "options", "selected", "disabled", "onChange"]);
    function handleClick(_a) {
        var name = _a.name, value = _a.value, isSelected = _a.isSelected;
        if (!onChange)
            return;
        if (isSelected) {
            onChange({ name: name, value: selected.filter(function (e) { return e !== value; }) });
        }
        else {
            onChange({ name: name, value: __spreadArray(__spreadArray([], __read(selected), false), [value], false) });
        }
    }
    function renderCard(index, option, isDisabled, checked) {
        var Check = place === 'right' ? CheckboxWithoutLabel : Checkbox;
        var checkWithoutLabel = (React.createElement(Check, { key: index, name: props.name, option: option, isDisabled: isDisabled, checked: checked }));
        var contentNode = (React.createElement(React.Fragment, null,
            option.image && React.createElement(ImageComp, { src: option.image, alt: "", isDisabled: isDisabled }),
            React.createElement(Body1, { title: option.text }),
            React.createElement(Body2, { title: option.subText })));
        if (place === 'left') {
            return (React.createElement(FlexBox, { gap: '8px' },
                checkWithoutLabel,
                React.createElement(BaseBox, { flex: 1 }, contentNode)));
        }
        return (React.createElement(React.Fragment, null,
            checkWithoutLabel,
            contentNode));
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Heading3, { fontWeight: 'medium', title: props.title }),
        React.createElement(Body1, { mb: 12, title: props.subTitle }),
        React.createElement(GridBox, { itemWidth: itemWidth }, (options || []).map(function (option, index) {
            var checked = selected.includes(option.value);
            var isDisabled = disabled.includes(option.value);
            return (React.createElement(CheckboxTile, { itemWidth: itemWidth, name: props.name, value: option.value, checked: checked, isDisabled: isDisabled, handleClick: handleClick }, renderCard(index, option, isDisabled, checked)));
        }))));
};
export default DoconCheckboxTile;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
